export default __webpack_public_path__ + "static/media/filter.4eb05036.svg";